import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { Suspense } from 'react'
import { useSessionStorage } from '@/hooks/useSessionStorage'
import { isTokenExpired } from '@/hooks/useTokenValidator'
import { hasLeftTabIntent } from '@/utils/tabSession'
import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router'

export function HomePage() {
  const [token] = useSessionStorage('token', '')
  const [searchParams] = useSearchParams()
  const { pathname } = useLocation()
  const leftTab = searchParams.get('leftTab') === '1'
  const loggedIn = !!token && !hasLeftTabIntent() && !isTokenExpired(token)
  const isMarketingHome = pathname === '/'

  if (leftTab) {
    return (
      <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3 px-6 text-center">
        <h2 className="text-lg font-semibold">This tab is no longer in use</h2>
        <p className="max-w-md text-sm text-foreground/70">
          Your session continues in the other browser tab. You can close this tab.
        </p>
      </div>
    )
  }

  if (loggedIn) {
    return <Navigate to="/workspaces" replace />
  }

  if (isMarketingHome) {
    return (
      <QueryErrorBoundary errorMessage="Something went wrong">
        <div className="h-full overflow-y-auto scroll-smooth">
          <Suspense fallback={<LoadingComponent />}>
            <Outlet />
          </Suspense>
        </div>
      </QueryErrorBoundary>
    )
  }

  return (
    <div className="px-5">
      <QueryErrorBoundary errorMessage="Something went wrong">
        <TablePageContainer fullHeight>
          <Suspense fallback={<div>Loading...</div>}>
            <Outlet />
          </Suspense>
        </TablePageContainer>
      </QueryErrorBoundary>
    </div>
  )
}
